import React from 'react';
import numeral from 'numeral';

const FormatCurrency = ({value}) => {
    
    const currency = numeral(value);
    return <span>{currency.format()} kr</span>
}
export default FormatCurrency;